module.exports = __webpack_public_path__ + "img/pProject-banner4.62d926f2.jpg";